export default "__VITE_ASSET__CJN2h$TM__"